<humi-badge [variant]="type">
    <ng-content></ng-content>
</humi-badge>
